export type Locale = 'ja' | 'en' | 'es';

export const SUPPORTED_LOCALES: readonly Locale[] = ['ja', 'en', 'es'];
export const DEFAULT_LOCALE: Locale = 'ja';

export const BASE_URL = 'https://baseballdataviewer.com';

const normalizePath = (pathname: string): string => {
  let normalized = pathname || '/';
  normalized = normalized.replace(/\/{2,}/g, '/');
  if (!normalized.startsWith('/')) normalized = `/${normalized}`;
  if (normalized.length > 1) normalized = normalized.replace(/\/+$/, '');
  return normalized || '/';
};

export const isSupportedLocale = (value: string | null | undefined): value is Locale => {
  return value === 'ja' || value === 'en' || value === 'es';
};

export const stripLocalePrefix = (pathname: string): string => {
  const normalized = normalizePath(pathname);
  const first = normalized.split('/')[1] || '';
  if (!isSupportedLocale(first)) return normalized;
  const stripped = normalized.slice(first.length + 1);
  if (!stripped) return '/';
  return stripped.startsWith('/') ? stripped : `/${stripped}`;
};

/**
 * ロケールプレフィックス付きパスを生成（末尾スラッシュあり）
 * 例: withLocalePrefix('ja', '/players') → '/ja/players/'
 */
export const withLocalePrefix = (locale: Locale, pathname: string): string => {
  const normalized = normalizePath(stripLocalePrefix(pathname));
  if (normalized === '/') return `/${locale}/`;
  return `/${locale}${normalized}/`;
};

/**
 * 絶対 canonical URL を生成
 */
export const canonicalUrl = (locale: Locale, basePath: string): string =>
  `${BASE_URL}${withLocalePrefix(locale, basePath)}`;

/**
 * hreflang 用の alternates を生成
 */
export const buildAlternates = (
  basePath: string,
): Record<string, string> & { 'x-default': string } => {
  const result = {} as Record<string, string> & { 'x-default': string };
  for (const locale of SUPPORTED_LOCALES) {
    result[locale] = `${BASE_URL}${withLocalePrefix(locale, basePath)}`;
  }
  result['x-default'] = `${BASE_URL}${withLocalePrefix(DEFAULT_LOCALE, basePath)}`;
  return result;
};

export const OG_LOCALE_MAP: Record<Locale, string> = {
  ja: 'ja_JP',
  en: 'en_US',
  es: 'es_ES',
};
